import type {ReactNode} from "react";

interface ActionsCellProps {
  children: ReactNode;
}

/**
 * ActionsCell — generic table cell wrapper for action buttons.
 *
 * Handles the "propagation guard" pattern: wrapping action buttons in a
 * clickable-row table requires stopping the click event before it bubbles up
 * to the row's `onRowAction` handler. This component centralizes that guard.
 *
 * Also enforces consistent right-alignment via `flex justify-end` so all
 * action columns are visually coherent across different entity tables.
 *
 * @example
 * ```tsx
 * columnHelper.display({
 *   id: "actions",
 *   cell: (info) => (
 *     <ActionsCell>
 *       <DeleteButton ... />
 *     </ActionsCell>
 *   ),
 *   header: "Actions",
 * })
 * ```
 */
export function ActionsCell({children}: ActionsCellProps) {
  return (
    <div className="flex justify-end gap-2" onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  );
}
